import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
import { ColorpickerContext } from './context';
import { defaultColors, defaultConfig } from './defaultConfig';
import Button from '../Button';
var ITEM_SIZE = 20;
var ITEM_GAP = 3;
var ColorPicker = (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, rowSpan = _a.rowSpan, size = _a.size, action = _a.action, onClickAction = _a.onClickAction;
            var classes = classNames(prefixCls, className);
            var actionClasses = classNames(prefixCls + "-action");
            var topActionClasses = classNames(actionClasses, actionClasses + "-top");
            var bottomActionClasses = classNames(actionClasses, actionClasses + "-bottom");
            return (h("div", { className: classes, style: __assign(__assign({}, style), { width: rowSpan * (size + ITEM_GAP) }) },
                Array.isArray(action) && action.map(function (actionItem, index) { return (actionItem.position === 'top'
                    && h(Button, { key: index, className: topActionClasses, onClick: actionItem.onClick }, actionItem.text)); }),
                h(ColorpickerContext.Provider, { value: size }, children),
                Array.isArray(action) ?
                    action.map(function (actionItem, index) { return (actionItem.position !== 'top'
                        && h(Button, { key: index, className: bottomActionClasses, onClick: actionItem.onClick }, actionItem.text)); })
                    : action && h(Button, { className: bottomActionClasses, onClick: onClickAction }, action)));
        };
        return _this;
    }
    ColorPicker.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    ColorPicker.defaultConfig = defaultConfig;
    ColorPicker.defaultColors = defaultColors;
    return ColorPicker;
}(React.Component));
export default ColorPicker;
ColorPicker.defaultProps = {
    prefixCls: 'dui-colorpicker',
    rowSpan: 7,
    size: ITEM_SIZE,
};
